import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const FinishLeadFirst = (props) => {
  const [loading, setLoading] = useState(false);
  const [courtOptions, setCourtOptions] = useState([]);
  const [court, setCourt] = useState(
    props.mode === "filled"
      ? props.leadData.finishCourt !== null
        ? props.leadData.finishCourt
        : ""
      : ""
  );
  const [caseCh, setCaseCh] = useState(
    props.mode === "filled"
      ? props.leadData.finishCaseCh !== null
        ? props.leadData.finishCaseCh
        : ""
      : "Nie"
  );
  const [team, setTeam] = useState(
    props.mode === "filled"
      ? props.leadData.finishTeam !== null && props.leadData.finishTeam !== ""
        ? props.leadData.finishTeam
        : props.user.team.length === 1
        ? props.user.team
        : "1"
      : props.user.team.length === 1
      ? props.user.team
      : "1"
  );
  const [courtList, setCourtList] = useState([]);
  const [note, setNote] = useState(
    props.mode === "filled"
      ? props.leadData.finishNote !== null
        ? props.leadData.finishNote
        : ""
      : ""
  );
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("sellFinish");
  const [files, setFiles] = useState([]);
  const [finishPayed, setFinishPayed] = useState(
    props.mode === "filled"
      ? props.leadData.finishPayed === "1"
        ? true
        : false
      : false
  );
  const [markAggr, setMarkAggr] = useState(
    props.mode === "filled"
      ? props.leadData.markAggr === "1"
        ? true
        : false
      : false
  );
  const [usersSend7, setUsersSend7] = useState([]);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const fetchCourts = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourts", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setCourtList(data);
        setCourtOptions(createCourtOptions(data));
        fetchFiles();
      })
      .catch((error) => {});
  };

  const createCourtOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({ label: el.name, value: el.name });
    });

    return bankOptions;
  };

  const fetchFiles = async () => {
    var body = { leadId: props.leadData.id };

    await fetch("https://apidevkppp.ftpeople.pl/getSellFilesLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFiles(
          data.filter((el) => el.type === "sellFinish" || el.type === "sell")
        );
        fetchUsersSend7();
      })
      .catch((error) => {});
  };

  const fetchUsersSend7 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend6", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend7(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = async () => {
    fetchCourts();
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const handleCaseChChange = (e) => {
    setCaseCh(e.target.value);
  };

  const handleTeamChange = (e) => {
    setTeam(e.target.value);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const saveFinalizeLead = async (e) => {
    if (validate()) {
      setLoading(true);

      var body = {
        id: props.leadData.id,
        court: court,
        caseCh: caseCh,
        team: team,
        note: note.replaceAll("'", '"'),
        finishPayed: finishPayed ? "1" : "0",
        markAggr: markAggr ? "1" : "0",
      };

      await fetch("https://apidevkppp.ftpeople.pl/markFinishLead", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          if (uploadFilesArray.length > 0) {
            var length = uploadFilesArray.length;
            var progr = 0;
            if (length > 0) {
              uploadFilesArray.map(async (file) => {
                let formData = new FormData();
                formData.append("file", file);
                formData.append("type", fileType);
                formData.append("leadId", props.leadData.id);
                formData.append("user", props.user.name);

                await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
                  method: "POST",
                  body: formData,
                })
                  .then((response) => {
                    return response.text();
                  })
                  .then((responseJson) => {
                    ++progr;
                    MySwal.fire({
                      icon: "success",
                      title: "Wysłano plik: " + progr + "/" + length,
                      text: "",
                    });
                  })
                  .then(async (result) => {
                    if (progr === length) {
                      var bodya = {
                        id: props.leadData.id,
                      };

                      await fetch(
                        "https://apidevkppp.ftpeople.pl/archivizeLead",
                        {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(bodya),
                        }
                      )
                        .then((response) => response.text())
                        .then((data) => {
                          emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                          var templateParams = {
                            to:
                              +team === 1
                                ? usersSend7.filter((el) => +el.team === 1)[0]
                                    .mail
                                : usersSend7.filter((el) => +el.team === 2)[0]
                                    .mail,
                            client: props.leadData.name,
                          };

                          emailjs
                            .send("KPPP", "template_q0f74tu", templateParams)
                            .then(
                              function (response) {
                                props.closeS();
                              },
                              function (error) {
                                MySwal.fire({
                                  icon: "error",
                                  title: "Błąd",
                                  text: "nie wysłano wiadomości e-mail. Ponów operację!",
                                }).then(async (result) => {
                                  props.closeS();
                                });
                              }
                            );
                        })
                        .catch((error) => {});
                    }
                  });
              });
            } else {
              var bodya = {
                id: props.leadData.id,
              };

              await fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(bodya),
              })
                .then((response) => response.text())
                .then((data) => {
                  emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                  var templateParams = {
                    to:
                      +team === 1
                        ? usersSend7.filter((el) => +el.team === 1)[0].mail
                        : usersSend7.filter((el) => +el.team === 2)[0].mail,
                    client: props.leadData.name,
                  };

                  emailjs.send("KPPP", "template_q0f74tu", templateParams).then(
                    function (response) {
                      props.closeS();
                    },
                    function (error) {
                      MySwal.fire({
                        icon: "error",
                        title: "Błąd",
                        text: "nie wysłano wiadomości e-mail. Ponów operację!",
                      }).then(async (result) => {
                        props.closeS();
                      });
                    }
                  );
                })
                .catch((error) => {});
            }
          } else {
            var bodya = {
              id: props.leadData.id,
            };

            await fetch("https://apidevkppp.ftpeople.pl/archivizeLead", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(bodya),
            })
              .then((response) => response.text())
              .then((data) => {
                emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
                var templateParams = {
                  to:
                    +team === 1
                      ? usersSend7.filter((el) => +el.team === 1)[0].mail
                      : usersSend7.filter((el) => +el.team === 2)[0].mail,
                  client: props.leadData.name,
                };

                emailjs.send("KPPP", "template_q0f74tu", templateParams).then(
                  function (response) {
                    props.closeS();
                  },
                  function (error) {}
                );
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
    }
  };

  const validate = () => {
    if (court.length > 0 && caseCh.length > 0 && team.length > 0) {
      return true;
    } else {
      return false;
    }
    return true;
  };

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSellFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "plik",
    }).then((result) => {
      props.logLeadAction("Usunięto plik", props.leadData.id);
      getData();
    });
  };

  const changeFileNameK = async (e) => {
    MySwal.fire({
      title: "Wprowadź nazwę pliku",
      input: "text",
      inputPlaceholder: "Nazwa pliku",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wprowadzić nazwę pliku");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          name: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setSellFileName", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = files.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name);
  };

  const documentsView = (
    <>
      {files.length > 0 ? (
        <>
          {files.filter((el) => el.type === "sellFinish" || el.type === "sell")
            .length > 0 ? (
            <>
              <p style={{ textTransform: "uppercase", fontSize: "1vw" }}>
                Pliki wgrane do zlecenia
              </p>
              <table
                style={{ width: "92%", fontSize: "0.6vw" }}
                id="detailClientTable"
                className="clients_table"
              >
                <tr>
                  <th>Nazwa pliku</th>
                  <th>Użytkownik</th>
                  <th>Data</th>
                  <th>Pokaż</th>
                  <th></th>
                </tr>
                {files
                  .filter(
                    (el) => el.type === "sellFinish" || el.type === "sell"
                  )
                  .map((file) => (
                    <>
                      <tr>
                        <td
                          style={{
                            width: "30%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.name}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.user}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {new Date(file.date).getFullYear() +
                            "-" +
                            (new Date(file.date).getMonth() + 1 < 10
                              ? "0" + (new Date(file.date).getMonth() + 1)
                              : new Date(file.date).getMonth() + 1) +
                            "-" +
                            (new Date(file.date).getDate() < 10
                              ? "0" + new Date(file.date).getDate()
                              : new Date(file.date).getDate())}{" "}
                          {(new Date(file.date).getHours() < 10
                            ? "0" + new Date(file.date).getHours()
                            : new Date(file.date).getHours()) +
                            ":" +
                            (new Date(file.date).getMinutes() < 10
                              ? "0" + new Date(file.date).getMinutes()
                              : new Date(file.date).getMinutes())}
                        </td>
                        <td
                          style={{
                            width: "10%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {file.link.includes("apidevkppp.ftpeople.pl") ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={downloadFile}
                              >
                                pokaż
                              </button>
                            </>
                          ) : (
                            <>
                              <a
                                style={{ textDecoration: "none" }}
                                className="refreshButton"
                                value={file.id}
                                href={file.link}
                                target="_blank"
                              >
                                pokaż
                              </a>
                            </>
                          )}
                        </td>
                        <td
                          style={{
                            width: "20%",
                            padding: "5px 20px",
                            height: "3vh",
                          }}
                        >
                          {props.view !== "client" ? (
                            <>
                              <button
                                className="refreshButton"
                                value={file.id}
                                onClick={deleteFile}
                              >
                                usuń
                              </button>
                              <button
                                style={{ marginLeft: "10px" }}
                                className="refreshButton"
                                value={file.id}
                                onClick={changeFileNameK}
                              >
                                zmień nazwę
                              </button>{" "}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    </>
                  ))}
              </table>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <div
      style={{ width: "60vw", top: "5vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          <div
            style={{
              paddingBottom: "20px",
              fontWeight: "600",
              fontSize: "1.5vw",
            }}
          >
            ZLECENIE ZAŁOŻENIA SPRAWY
          </div>
          <div
            id="addPaymentIC"
            className="inputContainer"
            style={{ maxHeight: "70vh", overflowY: "scroll" }}
          >
            <div className="inputBox" style={{ width: "92%" }}>
              <div className="inputCol_1">
                <label>
                  Wybierz Sąd <span className="requiredStar">*</span>
                </label>
                <Select
                  noOptionsMessage={() => "Brak danych"}
                  placeholder={"Wybierz..."}
                  isClearable={false}
                  options={courtOptions}
                  onChange={handleCourtChange}
                  value={{ label: court, value: court }}
                />
              </div>
            </div>
            <div className="inputBox" style={{ width: "87%" }}>
              <div className="inputCol_2">
                <label>
                  Wniosek o zabezpieczenie?{" "}
                  <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={caseCh}
                  onChange={handleCaseChChange}
                >
                  {caseCh === "" ? (
                    <>
                      <option key={0} value={""}>
                        {"Wybierz..."}
                      </option>
                    </>
                  ) : (
                    ""
                  )}
                  <option key={2} value={"Do decyzji prawnika"}>
                    Do decyzji prawnika
                  </option>
                  <option key={0} value={"TAK"}>
                    TAK
                  </option>
                  <option key={1} value={"NIE"}>
                    NIE
                  </option>
                </select>
              </div>
              <div className="inputCol_2">
                <label>
                  Zespół <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  disabled={props.user.team.length === 1 ? true : false}
                  value={team}
                  onChange={handleTeamChange}
                >
                  {caseCh === "" ? (
                    <>
                      <option key={0} value={""}>
                        {"Wybierz..."}
                      </option>
                    </>
                  ) : (
                    ""
                  )}

                  <option key={0} value={"1"}>
                    1
                  </option>
                  <option key={1} value={"2"}>
                    2
                  </option>
                </select>
              </div>
            </div>
            <div className="inputBox" style={{ width: "92%" }}>
              <div className="inputCol_1">
                <label>Notatka</label>
                <textarea
                  spellCheck="false"
                  className="textAreaNote"
                  type="text"
                  id="url"
                  name="url"
                  value={note}
                  onChange={handleNoteChange}
                />
              </div>
            </div>
            <div
              className="multiContainer"
              style={{ paddingTop: "2vh", width: "100%" }}
            >
              <div
                style={{
                  height: "2.5vh",
                  fontWeight: "300",
                  fontSize: "0.8vw",
                  width: "100%",
                }}
                className="checkBox"
              >
                <input
                  style={{ height: "2vh" }}
                  id="checkCal2"
                  type="checkbox"
                  checked={finishPayed}
                  onChange={(e) => {
                    setFinishPayed(e.target.checked);
                  }}
                />
                Kredyt spłacony
              </div>
            </div>

            <div
              className="inputBox"
              style={{
                display: "block",
              }}
            >
              <input multiple={true} type="file" onChange={changeFiles} />
              <>
                <div style={{ width: "92%" }} className="inputBox"></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                      <table
                        style={{ width: "92%", boxSizing: "border-box" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </div>
            <>{documentsView}</>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={saveFinalizeLead}>
                Zapisz
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FinishLeadFirst;
